module.exports = __webpack_public_path__ + "static/media/youtube.a94fed07.svg";